'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _find2 = require('lodash/find');

var _find3 = _interopRequireDefault(_find2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _cloneDeep2 = require('lodash/cloneDeep');

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _desc, _value, _class2;

var _mobx = require('mobx');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var CapitalFundingStore = (0, _classAutobindDecorator2.default)(_class = (_class2 = function () {
  function CapitalFundingStore(flatStore, lienStore, transport) {
    _classCallCheck(this, CapitalFundingStore);

    this.flatStore = flatStore;
    this.lienStore = lienStore;
    this.transport = transport;
  }

  _createClass(CapitalFundingStore, [{
    key: 'upsert',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(fundingDataArg) {
        var fundingData, funding;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                fundingData = (0, _cloneDeep3.default)(fundingDataArg);


                if ((0, _get3.default)(fundingData, 'capital_provider.customOption', false)) {
                  fundingData.capital_provider.id = _uuid2.default.v4();
                  delete fundingData.capital_provider.customOption;
                }

                _context.next = 4;
                return this.transport.post('/capital-fundings/', { data: fundingData });

              case 4:
                funding = _context.sent;

                this.lienStore.updateFunding(funding);
                return _context.abrupt('return', funding);

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function upsert(_x) {
        return _ref.apply(this, arguments);
      }

      return upsert;
    }()
  }, {
    key: 'delete',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(fundingId, lienId) {
        var lien;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.transport.delete('/capital-fundings/:id/', { urlParams: { id: fundingId } });

              case 2:
                lien = this.flatStore.lien.get(lienId);


                lien.capital_fundings = lien.capital_fundings.filter(function (funding) {
                  return funding.id !== fundingId;
                });

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _delete(_x2, _x3) {
        return _ref2.apply(this, arguments);
      }

      return _delete;
    }()
  }, {
    key: 'listProviders',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(params) {
        var response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.transport.get('/capital-providers/', { params: params });

              case 2:
                response = _context3.sent;
                return _context3.abrupt('return', response.results);

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function listProviders(_x4) {
        return _ref3.apply(this, arguments);
      }

      return listProviders;
    }()
  }, {
    key: 'getFundingByProvider',
    value: function getFundingByProvider(provider, lienId) {
      var fundings = this.flatStore.lien.get(lienId).capital_fundings,
          funding = (0, _find3.default)(fundings, function (funding) {
        return funding.capital_provider.id === provider.id;
      });

      return funding || null;
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return CapitalFundingStore;
}(), (_applyDecoratedDescriptor(_class2.prototype, 'upsert', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'upsert'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'delete', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'delete'), _class2.prototype)), _class2)) || _class;

var _default = CapitalFundingStore;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(CapitalFundingStore, 'CapitalFundingStore', '/app/src/stores/CapitalFundingStore.js');
  reactHotLoader.register(_default, 'default', '/app/src/stores/CapitalFundingStore.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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